import React from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import Link from 'components/CustomRoutingLink';
import {Typography} from 'components/Typography';
import {IBreadcrumb} from 'modules/seo/types';

interface IBreadcrumbsProps {
    breadcrumbs: IBreadcrumb[];
    shallow?: boolean;
    enableLastLink?: boolean;
}

export const Breadcrumbs = ({breadcrumbs, shallow, enableLastLink}: IBreadcrumbsProps) => {
    return (
        <nav className={classNames(style.main, {[style.disabledLastLink]: !enableLastLink})}>
            <ul className={style.breadCrumbsList} itemScope={true} itemType={'https://schema.org/BreadcrumbList'}>
                {breadcrumbs.map(({url, name}, index) => (
                    <li
                        className={style.breadCrumbsItem}
                        itemProp={'itemListElement'}
                        itemScope={true}
                        itemType={'https://schema.org/ListItem'}
                        key={name}
                    >
                        <Link href={url} legacyBehavior={true} passHref={true} shallow={shallow}>
                            <a className={style.link}>
                                <Typography
                                    data-skeleton-item={true}
                                    itemProp={'name'}
                                    variants={{DT: 'label-16-r', TB: 'label-16-r', MB: 'label-14-r'}}
                                >
                                    {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
                                    <span dangerouslySetInnerHTML={{__html: name}} />
                                </Typography>
                                <meta content={`${index + 1}`} itemProp={'position'} />
                                <link itemProp={'item'} href={url} />
                            </a>
                        </Link>
                        <div className={style.separator} />
                    </li>
                ))}
            </ul>
        </nav>
    );
};
